"use client";

import React from "react";
import type { NodeKind } from "./types";
import { NODE_META } from "./constants";

export function AddNodeButton({
  kind,
  onAdd,
}: {
  kind: NodeKind;
  onAdd: (kind: NodeKind) => void;
}) {
  const m = NODE_META[kind];
  const Icon = m.icon;
  return (
    <button
      onClick={() => onAdd(kind)}
      className={`flex items-center gap-1.5 rounded-xl border px-3 py-1.5 text-xs font-medium transition ${m.border} ${m.bg} ${m.color} hover:opacity-80`}
    >
      <Icon className="h-3.5 w-3.5" />
      {m.label}
    </button>
  );
}
